import Preview from './preview.svg';
import { ClaytonParkingContainer } from './ClaytonParkingContainer';
import { Icon } from '@monash/portal-react';

export const ClaytonParkingModule = {
  component: ClaytonParkingContainer,
  name: 'Clayton parking',
  previewImage: Preview,
  previewBackgroundColor: '#DBEAFE',
  description: 'See the parking spots available at Clayton campus.',
  users: ['Australia'],
  defaultSize: 'S',
  openEditMenuWhenAdded: true,
  additionalOptions: [
    {
      key: 'selectedCarparks',
      editType: null,
      default: [],
    },
  ],
  additionalActions: ({ setEditActiveWidget }) => [
    {
      action: ({ widgetId }) => {
        setEditActiveWidget(widgetId);
      },
      icon: <Icon.Pencil size={20} />,
      text: 'Add/Edit carparks',
      haspopup: 'dialog',
    },
  ],
};
